import { Component } from '@angular/core';

@Component({
  selector: 'lib-pin',
  imports: [],
  templateUrl: './pin.html',
})
export class PinIcon {}
